
import {tns} from 'tiny-slider/src/tiny-slider';
import VideoModal from '../../../components/VideoModal';
import * as skrollTop from 'skrolltop';
import Parallax from '../../../utils/Parallax';
import CounterAnimation from '../../../utils/CounterAnimation';
import OurProductsSpectaculars from './OurProductsSpectaculars';
import ImageModal from '../../../components/ImageModal';

class OurProducts{
    constructor(){
        this.main = document.getElementById('our_products');
        this._primeDigitalSliderContainer = this.main.querySelector('#our_products_prime_digital_slider');
        
        // onClick a los thumbs de videos abren VideoModal con el video correspondiente
        Array.from(this.main.querySelectorAll('.video-thumb')).forEach((videoThumb)=>{
            videoThumb.addEventListener('click', (e)=>{
                VideoModal.show(videoThumb.getAttribute('data-video'));
            })
        });

        // Init Parallax
        setTimeout(()=>{
            Parallax.init();
        },500);
        
        
        // Init CounterAnimation
        setTimeout(()=>{
            CounterAnimation.init();
        }, 0);

        setTimeout(()=>{
            this._spectaculars = new OurProductsSpectaculars();
        }, 500);
        
        // Deeplink by hash
        setTimeout(()=>{
            if(window.location.hash != ''){
                let to = null;
                switch(window.location.hash.substr(1)){
                    case 'spectaculars':
                        to = document.getElementById('our_products_spectaculars').offsetTop - 100;
                    break;
                    case 'digitals':
                        to = document.getElementById('our_products_digitals').offsetTop - 60;
                    break;
                    case 'statics':
                        to = document.getElementById('our_products_statics').offsetTop - 60;
                    break;
                    case 'med-media':
                        to = document.getElementById('our_products_med_media').offsetTop - 70;
                    break;
                    case 'zoom-media':
                        to = document.getElementById('our_products_zoom_media').offsetTop + 10;
                    break;
                    case 'fuel-ads':
                        to = document.getElementById('our_products_fuel_ads').offsetTop + 15;
                    break;
                }
    
                if(to != null){
                    window.location.hash = '';
                    skrollTop.scrollTo({
                        element: window,
                        to: to,
                        duration: 600
                    });
                }
            }
        }, 500)
        
        
        // Prime Digital slider
        if (this._primeDigitalSliderContainer.querySelectorAll('*:not(:empty)').length > 0) {
            this._primeDigitalSlider = tns({
                container: this._primeDigitalSliderContainer,
                nav: false,
                controls: false,
                mouseDrag: true,
                edgePadding: 40,
                speed: 500,
                loop: true,
                autoplay: false,
                autoplayButtonOutput: false,
                autoplayTimeout: 2000,
                slideBy: 1,
                preventScrollOnTouch: 'auto',
                swipeAngle: 45,
                center: true,
                items: 1,
                gutter: 2,
                responsive: {
                    590: {
                        items: 2,
                        edgePadding: 45,
                    },
                    768: {
                        items: 3,
                        edgePadding: 50,
                    },
                    1100: {
                        items: 4,
                        gutter: 0,
                        edgePadding: 0,
                    },
                    1600: {
                        items: 5,
                        gutter: 0,
                        edgePadding: 0,
                    },
                    2100: {
                        items: 6,
                    },
                    3100: {
                        items: 8,
                    },
                }
            });

            this._primeDigitalSlider.isDragging = false;// Create a flag to check dragging
            this._primeDigitalSlider.events.on('dragMove', () => {
                this._primeDigitalSlider.isDragging = true;
            });
            this._primeDigitalSlider.events.on('dragEnd', () => {
                this._primeDigitalSlider.isDragging = false;
            });


            Array.from(document.querySelectorAll('#our_products_prime_digital_slider > div')).forEach((item)=>{
                item.addEventListener('click', (e)=> {
                    e.preventDefault();
                    e.stopPropagation();

                    if(!this._primeDigitalSlider.isDragging){
                        ImageModal.show(item.getAttribute('data-image'));
                    }
                });
            });
        }
    }
}

export default OurProducts;